<template>
  <a-modal v-model:visible="modal.show" wrapClassName="modal_operate"
           :width="300" :footer="null" :closable="false" destroyOnClose>
    <a-typography-paragraph v-if="expand.current">
      {{ expand.type[expand.current] }}
    </a-typography-paragraph>
    <img alt=""
         :src="file.ImageQR" />
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'page_modalOperate',
  data(): DataInterface {
    return {
      file: {
        ImageQR
      },
      modal: {
        show: false
      },
      expand: {
        current: '',
        type: {
          freeUse: '您好，已收到您的试用需求，我们将尽快联系您。也欢迎通过扫描下方二维码联系我们。',
          reserve: '您好，已预约成功，我们将尽快联系您。也欢迎微信扫码联系我们。',
          learnMore: '您好，欢迎微信扫码了解详情。',
          deployment: '扫码添加企业小助手微信，回复“私有化部署”，预约部署体验',
          demo: '扫码添加企业小助手，回复“预约演示”，我们将为您提供产品演示等服务。'
        }
      }
    };
  },
  mounted(): void {
    this.checkOperate();
  },
  methods: {
    /**
     * 打开
     * @param {string} type 类型
     */
    async open(type: string): Promise<any> {
      const username = $Store.User().username;
      
      if (!$RQ.SSO.check()) {
        $RQ.SSO.login(location.href, type);
        return;
      }
      
      this.modal.show = true;
      this.expand.current = type;
      
      switch (type) {
        case 'freeUse':
          await $RQ.PushWebHook(username, $Enum.TextEnum.OperateFreeUse);
          break;
        case 'reserve':
          await $RQ.PushWebHook(username, $Enum.TextEnum.OperateReserve);
          break;
      }
    },
    
    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false;
      this.expand.current = '';
    },
    
    /**
     * 检测操作
     */
    async checkOperate(): Promise<any> {
      const operate = $Store.User().operate;
      
      $Store.User().clearOperate();
      
      if (operate === '' || !$RQ.SSO.check()) return;
      
      switch (operate) {
        case $Enum.SSOEnum.Register:
          $FN.Message('success', {
            content: $Enum.TextEnum.SuccessRegister
          });
          break;
        case $Enum.SSOEnum.Login:
          $FN.Message('success', {
            content: $Enum.TextEnum.SuccessLogin
          });
          break;
        case $Enum.SSOEnum.Logout:
          $FN.Message('success', {
            content: $Enum.TextEnum.SuccessLogout
          });
          break;
        default:
          await this.open(operate);
          break;
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@image: '@{src_image}';

.modal_operate {
  .ant-modal {
    max-width: 90%;
    
    .ant-modal-body {
      padding: 15px 20px;
    }
  }
  
  .ant-typography {
    margin: 0;
    .font(justify, @text_mo+@line_mo, @color_black, @text_mo);
  }
  
  img {
    display: block;
    width: 100%;
  }
}
</style>